/**
 * Format: Search
 * ------------------------------------------------------------------------------
 * - Format a search response from the Storefront API
 * - Outputted object should match that of the formatted Shopify API helper.
 * - https://shopify.dev/docs/api/storefront/latest/queries/search
 */
import { formatProduct } from '~/format/product'
import { decodeApiId, transformEdges } from '~/helpers/graphql'

/**
 * Formats response from Storefront API.
 * @param {Object} response - GraphQL Storefront response.
 * @returns {Boolean|Object}
 */
export function formatSearch(response) {
  const { search } = response

  if (!search) {
    return false
  }

  /**
   * Encode search terms to ensure generated URL is valid.
   */
  const terms = encodeURIComponent(mint.search.terms)

  const url = mint.routes.root === '/'
    ? `//${location.host}/search?q=${terms}`
    : `//${location.host}${mint.routes.root}/search?q=${terms}`

  const formattedSearch = {
    pageInfo: search?.pageInfo,
    terms,
    url,
  }

  formattedSearch.products = transformEdges(search)
    .map(responseProduct => formatProduct({ responseProduct }))

  return formattedSearch
}